
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";

/*
  // Added
  "localsBL.label": "Blue",
  "localsIC.label": "Spain",
  "localsME.label": "Serbia/Monten.",
  "localsMF.label": "Reunion",
  "localsOR.label": "Orange",
  "localsRS.label": "Serbia/Monten.",
  "localsSX.label": "Reunion",
  "localsTP.label": "East Timor",
  "localsZFD.label": "Switzerland",

  // Removed
  -FX -CS -SU -UK -YU
*/


const MESSAGES = defineMessages({
  localsME: {
    id: "localsME.label",
    defaultMessage: "Montenegro",
  },
  localsMF: {
    id: "localsMF.label",
    defaultMessage: "Reunion",
  },
  localsRS: {
    id: "localsRS.label",
    defaultMessage: "Serbia",
  },
  localsTP: {
    id: "localsTP.label",
    defaultMessage: "East Timor",
  },
  localsAD: {
    id: "localsAD.label",
    defaultMessage: "Andorra",
  },
  localsAE: {
    id: "localsAE.label",
    defaultMessage: "Vereinigte Arabische Emirate",
  },
  localsAF: {
    id: "localsAF.label",
    defaultMessage: "Afghanistan",
  },
  localsAG: {
    id: "localsAG.label",
    defaultMessage: "Antigua und Barbuda",
  },
  localsAI: {
    id: "localsAI.label",
    defaultMessage: "Anguilla",
  },
  localsAL: {
    id: "localsAL.label",
    defaultMessage: "Albanien",
  },
  localsAM: {
    id: "localsAM.label",
    defaultMessage: "Armenien",
  },
  localsAN: {
    id: "localsAN.label",
    defaultMessage: "Niederländische Antillen",
  },
  localsAO: {
    id: "localsAO.label",
    defaultMessage: "Angola",
  },
  localsAQ: {
    id: "localsAQ.label",
    defaultMessage: "Antarktis",
  },
  localsAR: {
    id: "localsAR.label",
    defaultMessage: "Argentinien",
  },
  localsAS: {
    id: "localsAS.label",
    defaultMessage: "Samoa",
  },
  localsAT: {
    id: "localsAT.label",
    defaultMessage: "Österreich",
  },
  localsAU: {
    id: "localsAU.label",
    defaultMessage: "Australien",
  },
  localsAW: {
    id: "localsAW.label",
    defaultMessage: "Aruba",
  },
  localsAZ: {
    id: "localsAZ.label",
    defaultMessage: "Aserbaidschan",
  },
  localsBA: {
    id: "localsBA.label",
    defaultMessage: "Bosnien-Herzegowina",
  },
  localsBB: {
    id: "localsBB.label",
    defaultMessage: "Barbados",
  },
  localsBD: {
    id: "localsBD.label",
    defaultMessage: "Bangladesh",
  },
  localsBE: {
    id: "localsBE.label",
    defaultMessage: "Belgien",
  },
  localsBF: {
    id: "localsBF.label",
    defaultMessage: "Burkina Faso",
  },
  localsBG: {
    id: "localsBG.label",
    defaultMessage: "Bulgarien",
  },
  localsBH: {
    id: "localsBH.label",
    defaultMessage: "Bahrain",
  },
  localsBI: {
    id: "localsBI.label",
    defaultMessage: "Burundi",
  },
  localsBJ: {
    id: "localsBJ.label",
    defaultMessage: "Benin",
  },
  localsBM: {
    id: "localsBM.label",
    defaultMessage: "Bermudas",
  },
  localsBN: {
    id: "localsBN.label",
    defaultMessage: "Brunei",
  },
  localsBO: {
    id: "localsBO.label",
    defaultMessage: "Bolivien",
  },
  localsBR: {
    id: "localsBR.label",
    defaultMessage: "Brasilien",
  },
  localsBS: {
    id: "localsBS.label",
    defaultMessage: "Bahamas",
  },
  localsBT: {
    id: "localsBT.label",
    defaultMessage: "Bhutan",
  },
  localsBV: {
    id: "localsBV.label",
    defaultMessage: "Bouvet-Inseln",
  },
  localsBW: {
    id: "localsBW.label",
    defaultMessage: "Botswana",
  },
  localsBY: {
    id: "localsBY.label",
    defaultMessage: "Weißrussland",
  },
  localsBZ: {
    id: "localsBZ.label",
    defaultMessage: "Belize",
  },
  localsCA: {
    id: "localsCA.label",
    defaultMessage: "Kanada",
  },
  localsCC: {
    id: "localsCC.label",
    defaultMessage: "Kokosinseln",
  },
  localsCD: {
    id: "localsCD.label",
    defaultMessage: "Demokratische Republik Kongo (ehemals ZR: Zaire)",
  },
  localsCF: {
    id: "localsCF.label",
    defaultMessage: "Zentralafrikanische Republik",
  },
  localsCG: {
    id: "localsCG.label",
    defaultMessage: "Kongo",
  },
  localsCH: {
    id: "localsCH.label",
    defaultMessage: "Schweiz",
  },
  localsCI: {
    id: "localsCI.label",
    defaultMessage: "Elfenbeinküste",
  },
  localsCK: {
    id: "localsCK.label",
    defaultMessage: "Cook-Inseln",
  },
  localsCL: {
    id: "localsCL.label",
    defaultMessage: "Chile",
  },
  localsCM: {
    id: "localsCM.label",
    defaultMessage: "Kamerun",
  },
  localsCN: {
    id: "localsCN.label",
    defaultMessage: "China",
  },
  localsCO: {
    id: "localsCO.label",
    defaultMessage: "Kolumbien",
  },
  localsCR: {
    id: "localsCR.label",
    defaultMessage: "Costa Rica",
  },
  localsCS: {
    id: "localsCS.label",
    defaultMessage: "Serbien und Montenegro (früher Tschechoslowakei)",
  },
  localsCU: {
    id: "localsCU.label",
    defaultMessage: "Kuba",
  },
  localsCV: {
    id: "localsCV.label",
    defaultMessage: "Kap Verde",
  },
  localsCX: {
    id: "localsCX.label",
    defaultMessage: "Christmas Island",
  },
  localsCY: {
    id: "localsCY.label",
    defaultMessage: "Zypern",
  },
  localsCZ: {
    id: "localsCZ.label",
    defaultMessage: "Tschechische Republik",
  },
  localsDE: {
    id: "localsDE.label",
    defaultMessage: "Deutschland",
  },
  localsDJ: {
    id: "localsDJ.label",
    defaultMessage: "Djibuti",
  },
  localsDK: {
    id: "localsDK.label",
    defaultMessage: "Dänemark",
  },
  localsDM: {
    id: "localsDM.label",
    defaultMessage: "Dominika",
  },
  localsDO: {
    id: "localsDO.label",
    defaultMessage: "Dominikanische Republik",
  },
  localsDZ: {
    id: "localsDZ.label",
    defaultMessage: "Algerien",
  },
  localsEC: {
    id: "localsEC.label",
    defaultMessage: "Ecuador",
  },
  localsEE: {
    id: "localsEE.label",
    defaultMessage: "Estland",
  },
  localsEG: {
    id: "localsEG.label",
    defaultMessage: "Ägypten",
  },
  localsEH: {
    id: "localsEH.label",
    defaultMessage: "Westsahara",
  },
  localsER: {
    id: "localsER.label",
    defaultMessage: "Eritrea",
  },
  localsES: {
    id: "localsES.label",
    defaultMessage: "Spanien",
  },
  localsET: {
    id: "localsET.label",
    defaultMessage: "Äthiopien",
  },
  localsFI: {
    id: "localsFI.label",
    defaultMessage: "Finnland",
  },
  localsFJ: {
    id: "localsFJ.label",
    defaultMessage: "Fidschi-Inseln",
  },
  localsFK: {
    id: "localsFK.label",
    defaultMessage: "Falkland-Inseln",
  },
  localsFM: {
    id: "localsFM.label",
    defaultMessage: "Mikronesien",
  },
  localsFO: {
    id: "localsFO.label",
    defaultMessage: "Färöer Inseln",
  },
  localsFR: {
    id: "localsFR.label",
    defaultMessage: "Frankreich",
  },
  localsFX: {
    id: "localsFX.label",
    defaultMessage: "Frankreich (nur Europa)",
  },
  localsGA: {
    id: "localsGA.label",
    defaultMessage: "Gabun",
  },
  localsGB: {
    id: "localsGB.label",
    defaultMessage: "Großbritannien (UK)",
  },
  localsGD: {
    id: "localsGD.label",
    defaultMessage: "Grenada",
  },
  localsGE: {
    id: "localsGE.label",
    defaultMessage: "Georgien",
  },
  localsGF: {
    id: "localsGF.label",
    defaultMessage: "französisch Guyana",
  },
  localsGH: {
    id: "localsGH.label",
    defaultMessage: "Ghana",
  },
  localsGI: {
    id: "localsGI.label",
    defaultMessage: "Gibraltar",
  },
  localsGL: {
    id: "localsGL.label",
    defaultMessage: "Grönland",
  },
  localsGM: {
    id: "localsGM.label",
    defaultMessage: "Gambia",
  },
  localsGN: {
    id: "localsGN.label",
    defaultMessage: "Guinea",
  },
  localsGP: {
    id: "localsGP.label",
    defaultMessage: "Guadeloupe",
  },
  localsGQ: {
    id: "localsGQ.label",
    defaultMessage: "Äquatorial Guinea",
  },
  localsGR: {
    id: "localsGR.label",
    defaultMessage: "Griechenland",
  },
  localsGS: {
    id: "localsGS.label",
    defaultMessage: "South Georgia und South Sandwich Islands",
  },
  localsGT: {
    id: "localsGT.label",
    defaultMessage: "Guatemala",
  },
  localsGU: {
    id: "localsGU.label",
    defaultMessage: "Guam",
  },
  localsGW: {
    id: "localsGW.label",
    defaultMessage: "Guinea Bissau",
  },
  localsGY: {
    id: "localsGY.label",
    defaultMessage: "Guyana",
  },
  localsHK: {
    id: "localsHK.label",
    defaultMessage: "Hong Kong",
  },
  localsHM: {
    id: "localsHM.label",
    defaultMessage: "Heard und McDonald Islands",
  },
  localsHN: {
    id: "localsHN.label",
    defaultMessage: "Honduras",
  },
  localsHR: {
    id: "localsHR.label",
    defaultMessage: "Kroatien",
  },
  localsHT: {
    id: "localsHT.label",
    defaultMessage: "Haiti",
  },
  localsHU: {
    id: "localsHU.label",
    defaultMessage: "Ungarn",
  },
  localsID: {
    id: "localsID.label",
    defaultMessage: "Indonesien",
  },
  localsIE: {
    id: "localsIE.label",
    defaultMessage: "Irland",
  },
  localsIL: {
    id: "localsIL.label",
    defaultMessage: "Israel",
  },
  localsIN: {
    id: "localsIN.label",
    defaultMessage: "Indien",
  },
  localsIO: {
    id: "localsIO.label",
    defaultMessage: "Britisch-Indischer Ozean",
  },
  localsIQ: {
    id: "localsIQ.label",
    defaultMessage: "Irak",
  },
  localsIR: {
    id: "localsIR.label",
    defaultMessage: "Iran",
  },
  localsIS: {
    id: "localsIS.label",
    defaultMessage: "Island",
  },
  localsIT: {
    id: "localsIT.label",
    defaultMessage: "Italien",
  },
  localsJM: {
    id: "localsJM.label",
    defaultMessage: "Jamaika",
  },
  localsJO: {
    id: "localsJO.label",
    defaultMessage: "Jordanien",
  },
  localsJP: {
    id: "localsJP.label",
    defaultMessage: "Japan",
  },
  localsKE: {
    id: "localsKE.label",
    defaultMessage: "Kenia",
  },
  localsKG: {
    id: "localsKG.label",
    defaultMessage: "Kirgisistan",
  },
  localsKH: {
    id: "localsKH.label",
    defaultMessage: "Kambodscha",
  },
  localsKI: {
    id: "localsKI.label",
    defaultMessage: "Kiribati",
  },
  localsKM: {
    id: "localsKM.label",
    defaultMessage: "Komoren",
  },
  localsKN: {
    id: "localsKN.label",
    defaultMessage: "St. Kitts Nevis Anguilla",
  },
  localsKP: {
    id: "localsKP.label",
    defaultMessage: "Nordkorea",
  },
  localsKR: {
    id: "localsKR.label",
    defaultMessage: "Südkorea",
  },
  localsKW: {
    id: "localsKW.label",
    defaultMessage: "Kuwait",
  },
  localsKY: {
    id: "localsKY.label",
    defaultMessage: "Kaiman-Inseln",
  },
  localsKZ: {
    id: "localsKZ.label",
    defaultMessage: "Kasachstan",
  },
  localsLA: {
    id: "localsLA.label",
    defaultMessage: "Laos",
  },
  localsLB: {
    id: "localsLB.label",
    defaultMessage: "Libanon",
  },
  localsLC: {
    id: "localsLC.label",
    defaultMessage: "Saint Lucia",
  },
  localsLI: {
    id: "localsLI.label",
    defaultMessage: "Liechtenstein",
  },
  localsLK: {
    id: "localsLK.label",
    defaultMessage: "Sri Lanka",
  },
  localsLR: {
    id: "localsLR.label",
    defaultMessage: "Liberia",
  },
  localsLS: {
    id: "localsLS.label",
    defaultMessage: "Lesotho",
  },
  localsLT: {
    id: "localsLT.label",
    defaultMessage: "Litauen",
  },
  localsLU: {
    id: "localsLU.label",
    defaultMessage: "Luxemburg",
  },
  localsLV: {
    id: "localsLV.label",
    defaultMessage: "Lettland",
  },
  localsLY: {
    id: "localsLY.label",
    defaultMessage: "Libyen",
  },
  localsMA: {
    id: "localsMA.label",
    defaultMessage: "Marokko",
  },
  localsMC: {
    id: "localsMC.label",
    defaultMessage: "Monaco",
  },
  localsMD: {
    id: "localsMD.label",
    defaultMessage: "Moldavien",
  },
  localsMG: {
    id: "localsMG.label",
    defaultMessage: "Madagaskar",
  },
  localsMH: {
    id: "localsMH.label",
    defaultMessage: "Marshall-Inseln",
  },
  localsMK: {
    id: "localsMK.label",
    defaultMessage: "Mazedonien",
  },
  localsML: {
    id: "localsML.label",
    defaultMessage: "Mali",
  },
  localsMM: {
    id: "localsMM.label",
    defaultMessage: "Myanmar",
  },
  localsMN: {
    id: "localsMN.label",
    defaultMessage: "Mongolei",
  },
  localsMO: {
    id: "localsMO.label",
    defaultMessage: "Macao",
  },
  localsMP: {
    id: "localsMP.label",
    defaultMessage: "Marianen",
  },
  localsMQ: {
    id: "localsMQ.label",
    defaultMessage: "Martinique",
  },
  localsMR: {
    id: "localsMR.label",
    defaultMessage: "Mauretanien",
  },
  localsMS: {
    id: "localsMS.label",
    defaultMessage: "Montserrat",
  },
  localsMT: {
    id: "localsMT.label",
    defaultMessage: "Malta",
  },
  localsMU: {
    id: "localsMU.label",
    defaultMessage: "Mauritius",
  },
  localsMV: {
    id: "localsMV.label",
    defaultMessage: "Malediven",
  },
  localsMW: {
    id: "localsMW.label",
    defaultMessage: "Malawi",
  },
  localsMX: {
    id: "localsMX.label",
    defaultMessage: "Mexiko",
  },
  localsMY: {
    id: "localsMY.label",
    defaultMessage: "Malaysia",
  },
  localsMZ: {
    id: "localsMZ.label",
    defaultMessage: "Mocambique",
  },
  localsNA: {
    id: "localsNA.label",
    defaultMessage: "Namibia",
  },
  localsNC: {
    id: "localsNC.label",
    defaultMessage: "Neukaledonien",
  },
  localsNE: {
    id: "localsNE.label",
    defaultMessage: "Niger",
  },
  localsNF: {
    id: "localsNF.label",
    defaultMessage: "Norfolk-Inseln",
  },
  localsNG: {
    id: "localsNG.label",
    defaultMessage: "Nigeria",
  },
  localsNI: {
    id: "localsNI.label",
    defaultMessage: "Nicaragua",
  },
  localsNL: {
    id: "localsNL.label",
    defaultMessage: "Niederlande",
  },
  localsNO: {
    id: "localsNO.label",
    defaultMessage: "Norwegen",
  },
  localsNP: {
    id: "localsNP.label",
    defaultMessage: "Nepal",
  },
  localsNR: {
    id: "localsNR.label",
    defaultMessage: "Nauru",
  },
  localsNU: {
    id: "localsNU.label",
    defaultMessage: "Niue",
  },
  localsNZ: {
    id: "localsNZ.label",
    defaultMessage: "Neuseeland",
  },
  localsOM: {
    id: "localsOM.label",
    defaultMessage: "Oman",
  },
  localsPA: {
    id: "localsPA.label",
    defaultMessage: "Panama",
  },
  localsPE: {
    id: "localsPE.label",
    defaultMessage: "Peru",
  },
  localsPF: {
    id: "localsPF.label",
    defaultMessage: "Französisch-Polynesien",
  },
  localsPG: {
    id: "localsPG.label",
    defaultMessage: "Papua Neuguinea",
  },
  localsPH: {
    id: "localsPH.label",
    defaultMessage: "Philippinen",
  },
  localsPK: {
    id: "localsPK.label",
    defaultMessage: "Pakistan",
  },
  localsPL: {
    id: "localsPL.label",
    defaultMessage: "Polen",
  },
  localsPM: {
    id: "localsPM.label",
    defaultMessage: "St. Pierre und Miquelon",
  },
  localsPN: {
    id: "localsPN.label",
    defaultMessage: "Pitcairn",
  },
  localsPR: {
    id: "localsPR.label",
    defaultMessage: "Puerto Rico",
  },
  localsPS: {
    id: "localsPS.label",
    defaultMessage: "Palästinensische Selbstverwaltungsgebiete",
  },
  localsPT: {
    id: "localsPT.label",
    defaultMessage: "Portugal",
  },
  localsPW: {
    id: "localsPW.label",
    defaultMessage: "Palau",
  },
  localsPY: {
    id: "localsPY.label",
    defaultMessage: "Paraguay",
  },
  localsQA: {
    id: "localsQA.label",
    defaultMessage: "Qatar",
  },
  localsRE: {
    id: "localsRE.label",
    defaultMessage: "Reunion",
  },
  localsRO: {
    id: "localsRO.label",
    defaultMessage: "Rumänien",
  },
  localsRU: {
    id: "localsRU.label",
    defaultMessage: "Russland",
  },
  localsRW: {
    id: "localsRW.label",
    defaultMessage: "Ruanda",
  },
  localsSA: {
    id: "localsSA.label",
    defaultMessage: "Saudi-Arabien",
  },
  localsSB: {
    id: "localsSB.label",
    defaultMessage: "Solomon-Inseln",
  },
  localsSC: {
    id: "localsSC.label",
    defaultMessage: "Seychellen",
  },
  localsSD: {
    id: "localsSD.label",
    defaultMessage: "Sudan",
  },
  localsSE: {
    id: "localsSE.label",
    defaultMessage: "Schweden",
  },
  localsSG: {
    id: "localsSG.label",
    defaultMessage: "Singapur",
  },
  localsSH: {
    id: "localsSH.label",
    defaultMessage: "St. Helena",
  },
  localsSI: {
    id: "localsSI.label",
    defaultMessage: "Slowenien",
  },
  localsSJ: {
    id: "localsSJ.label",
    defaultMessage: "Svalbard und Jan Mayen Islands",
  },
  localsSK: {
    id: "localsSK.label",
    defaultMessage: "Slowakei (Slowakische Republik)",
  },
  localsSL: {
    id: "localsSL.label",
    defaultMessage: "Sierra Leone",
  },
  localsSM: {
    id: "localsSM.label",
    defaultMessage: "San Marino",
  },
  localsSN: {
    id: "localsSN.label",
    defaultMessage: "Senegal",
  },
  localsSO: {
    id: "localsSO.label",
    defaultMessage: "Somalia",
  },
  localsSR: {
    id: "localsSR.label",
    defaultMessage: "Surinam",
  },
  localsST: {
    id: "localsST.label",
    defaultMessage: "Sao Tome",
  },
  localsSV: {
    id: "localsSV.label",
    defaultMessage: "El Salvador",
  },
  localsSY: {
    id: "localsSY.label",
    defaultMessage: "Syrien",
  },
  localsSZ: {
    id: "localsSZ.label",
    defaultMessage: "Swasiland",
  },
  localsTC: {
    id: "localsTC.label",
    defaultMessage: "Turks- und Kaikos-Inseln",
  },
  localsTD: {
    id: "localsTD.label",
    defaultMessage: "Tschad",
  },
  localsTF: {
    id: "localsTF.label",
    defaultMessage: "Französisches Süd-Territorium",
  },
  localsTG: {
    id: "localsTG.label",
    defaultMessage: "Togo",
  },
  localsTH: {
    id: "localsTH.label",
    defaultMessage: "Thailand",
  },
  localsTJ: {
    id: "localsTJ.label",
    defaultMessage: "Tadschikistan",
  },
  localsTK: {
    id: "localsTK.label",
    defaultMessage: "Tokelau",
  },
  localsTL: {
    id: "localsTL.label",
    defaultMessage: "Ost-Timor",
  },
  localsTM: {
    id: "localsTM.label",
    defaultMessage: "Turkmenistan",
  },
  localsTN: {
    id: "localsTN.label",
    defaultMessage: "Tunesien",
  },
  localsTO: {
    id: "localsTO.label",
    defaultMessage: "Tonga",
  },
  localsTR: {
    id: "localsTR.label",
    defaultMessage: "Türkei",
  },
  localsTT: {
    id: "localsTT.label",
    defaultMessage: "Trinidad Tobago",
  },
  localsTV: {
    id: "localsTV.label",
    defaultMessage: "Tuvalu",
  },
  localsTW: {
    id: "localsTW.label",
    defaultMessage: "Taiwan",
  },
  localsTZ: {
    id: "localsTZ.label",
    defaultMessage: "Tansania",
  },
  localsUA: {
    id: "localsUA.label",
    defaultMessage: "Ukraine",
  },
  localsUG: {
    id: "localsUG.label",
    defaultMessage: "Uganda",
  },
  localsUK: {
    id: "localsUK.label",
    defaultMessage: "Großbritannien",
  },
  localsUM: {
    id: "localsUM.label",
    defaultMessage: "US- kleinere Inseln außerhalb",
  },
  localsUS: {
    id: "localsUS.label",
    defaultMessage: "Vereinigte Staaten von Amerika",
  },
  localsUY: {
    id: "localsUY.label",
    defaultMessage: "Uruguay",
  },
  localsUZ: {
    id: "localsUZ.label",
    defaultMessage: "Usbekistan",
  },
  localsVA: {
    id: "localsVA.label",
    defaultMessage: "Vatikan",
  },
  localsVC: {
    id: "localsVC.label",
    defaultMessage: "St. Vincent",
  },
  localsVE: {
    id: "localsVE.label",
    defaultMessage: "Venezuela",
  },
  localsVG: {
    id: "localsVG.label",
    defaultMessage: "Virgin Island (Brit.)",
  },
  localsVI: {
    id: "localsVI.label",
    defaultMessage: "Virgin Island (USA)",
  },
  localsVN: {
    id: "localsVN.label",
    defaultMessage: "Vietnam",
  },
  localsVU: {
    id: "localsVU.label",
    defaultMessage: "Vanuatu",
  },
  localsWF: {
    id: "localsWF.label",
    defaultMessage: "Wallis et Futuna",
  },
  localsWS: {
    id: "localsWS.label",
    defaultMessage: "Samoa",
  },
  localsYE: {
    id: "localsYE.label",
    defaultMessage: "Jemen",
  },
  localsYT: {
    id: "localsYT.label",
    defaultMessage: "Mayotte",
  },
  localsZA: {
    id: "localsZA.label",
    defaultMessage: "Südafrika",
  },
  localsZM: {
    id: "localsZM.label",
    defaultMessage: "Sambia",
  },
  localsZW: {
    id: "localsZW.label",
    defaultMessage: "Zimbabwe",
  },
  localsIC1: {
    id: "localsIC1.label",
    defaultMessage: "Intercompany FAR IC",
  },
  localsIC2: {
    id: "localsIC2.label",
    defaultMessage: "Intercompany FAH IC",
  },
});

export default MESSAGES;